/** 合约资金流水 typeCode → i18n（后端 /account/fund 未下发时的前端兜底） */
export const FUND_FLOW_BILL_TYPE_I18N: Record<string, string> = {
  BALANCE_BILL_TYPE_WELFARE_FEE_COUPON_GRANT: 'record.fundType.14',
  BALANCE_BILL_TYPE_WELFARE_FEE_COUPON_RECYCLE: 'record.fundType.15',
  BALANCE_BILL_TYPE_WELFARE_PNL_COUPON_GRANT: 'record.fundType.16',
  BALANCE_BILL_TYPE_WELFARE_PNL_COUPON_RECYCLE: 'record.fundType.17',
  BALANCE_BILL_TYPE_PROFIT_BONUS: 'record.fundType.18',
};

/** 需保证出现在类型下拉的 welfare 流水（API 未返回时前端补全） */
export const EXTRA_FUND_FLOW_BILL_TYPE_CODES = Object.keys(FUND_FLOW_BILL_TYPE_I18N);

export type FundFlowBillTypeItem = { code: string; value?: string };

export const mergeFundFlowBillTypes = (apiList: FundFlowBillTypeItem[] = []) => {
  const list = [...apiList];
  const codeSet = new Set(list.map(item => item.code));

  EXTRA_FUND_FLOW_BILL_TYPE_CODES.forEach(code => {
    if (!codeSet.has(code)) {
      list.push({ code, value: code });
      codeSet.add(code);
    }
  });

  return list;
};

type TranslateFn = (key: string, options?: { defaultValue?: string }) => string;

/** 下拉/表格展示：优先 i18n，其次接口 value */
export const resolveFundFlowBillTypeLabel = (
  code: string,
  options?: { apiValue?: string; t?: TranslateFn },
) => {
  if (!code) return '--';

  const i18nKey = FUND_FLOW_BILL_TYPE_I18N[code];
  if (i18nKey && options?.t) {
    return options.t(i18nKey, { defaultValue: options.apiValue || code });
  }
  if (i18nKey) {
    return i18nKey;
  }

  const apiValue = options?.apiValue;
  if (apiValue && apiValue !== code) return apiValue;
  return code;
};
